var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHasKeyfob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.144 17.938a3.997 3.997 0 01-5.656 0l-1.415-1.412a4 4 0 010-5.657l4.95-4.949a3.999 3.999 0 015.657 0l1.414 1.414a3.998 3.998 0 010 5.655l-4.95 4.949z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.911 4.856l-6.01 6.011a2 2 0 000 2.828l1.414 1.414a2 2 0 002.828 0L15.154 9.1",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73 13.696l-1.414-1.414 1.414-1.415 1.414 1.415-1.414 1.414zm2.829-2.828L9.144 9.453 10.56 8.04l1.414 1.414-1.414 1.415zM15.5 1.5a3 3 0 110 6 3 3 0 010-6z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.5a3 3 0 110 6 3 3 0 010-6zm-2 10a2 2 0 012-2h2c1.103 0 2 .896 2 2v3h-6v-3zm4 3h-2v5l1.042 2 .958-2z",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13V8",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}
export default SvgHasKeyfob;